
import { useEffect, useState } from 'react';

const FloatingSocialIcons = () => {
  const [icons, setIcons] = useState<Array<{
    id: number;
    icon: string;
    x: number;
    y: number;
    vx: number;
    vy: number;
    color: string;
  }>>([]);

  const socialIcons = [
    { icon: 'ri-facebook-fill', color: 'text-blue-500' },
    { icon: 'ri-instagram-fill', color: 'text-pink-500' },
    { icon: 'ri-twitter-x-fill', color: 'text-purple-500' },
    { icon: 'ri-linkedin-fill', color: 'text-blue-600' },
    { icon: 'ri-youtube-fill', color: 'text-red-500' },
    { icon: 'ri-tiktok-fill', color: 'text-gray-800' },
    { icon: 'ri-pinterest-fill', color: 'text-red-600' },
    { icon: 'ri-snapchat-fill', color: 'text-yellow-400' },
  ];

  useEffect(() => {
    const initialIcons = Array.from({ length: 15 }, (_, i) => ({
      id: i,
      icon: socialIcons[i % socialIcons.length].icon,
      color: socialIcons[i % socialIcons.length].color,
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      vx: (Math.random() - 0.5) * 0.5,
      vy: (Math.random() - 0.5) * 0.5,
    }));
    setIcons(initialIcons);

    const animateIcons = () => {
      setIcons(prevIcons =>
        prevIcons.map(icon => {
          let newX = icon.x + icon.vx;
          let newY = icon.y + icon.vy;
          let newVx = icon.vx;
          let newVy = icon.vy;

          if (newX <= 0 || newX >= window.innerWidth - 40) {
            newVx = -newVx;
            newX = Math.max(0, Math.min(window.innerWidth - 40, newX));
          }
          if (newY <= 0 || newY >= window.innerHeight - 40) {
            newVy = -newVy;
            newY = Math.max(0, Math.min(window.innerHeight - 40, newY));
          }

          return {
            ...icon,
            x: newX,
            y: newY,
            vx: newVx,
            vy: newVy,
          };
        })
      );
    };

    const interval = setInterval(animateIcons, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {icons.map(icon => (
        <div
          key={icon.id}
          className={`absolute transition-all duration-75 ${icon.color} opacity-20`}
          style={{
            left: `${icon.x}px`,
            top: `${icon.y}px`,
            transform: 'translate(-50%, -50%)',
          }}
        >
          <i className={`${icon.icon} text-4xl`}></i>
        </div>
      ))}
    </div>
  );
};

export default FloatingSocialIcons;
